export default "__VITE_ASSET__eHARxKLG__"